import TextArea, { TextAreaProps } from 'antd/es/input/TextArea';
import classNames from 'classnames';

interface MTextAreaProps extends TextAreaProps {}

const MTextArea: React.FC<MTextAreaProps> = (props) => {
  const { className, ...restProps } = props;
  return (
    <TextArea
      {...restProps}
      className={classNames('trojan-textarea trojan-input', className)}
    />
  );
};

export default MTextArea;
